import type { BookDiscoveryCard } from '../navigation/context'
import type { RecoveryItem } from './recovery'

/** Source-only cards must never manufacture a group or financial selection. */
export function bookGroupForCard(card: BookDiscoveryCard): string | null {
  const financial = card.proposal_ids.length > 0 || (card.held_item_ids?.length ?? 0) > 0
  if (!card.group_id) {
    if (financial) throw new Error('This document review has no verified Book group.')
    return null
  }
  return financial ? card.group_id : null
}

export function sourceQuestionBelongsToCard(
  item: RecoveryItem,
  taskId: string,
  documentIds: readonly string[]
): boolean {
  return (
    item.task_id === taskId &&
    item.source_question_kind !== null &&
    ['open', 'in_progress', 'pending_send', 'snoozed'].includes(item.status) &&
    item.subject?.kind === 'document' &&
    documentIds.includes(item.subject.id) &&
    item.documents.some((document) => document.document_id === item.subject?.id)
  )
}
